import { Link } from "react-router-dom";
import type { SyncRun } from "../lib/types";
import { fmtSgtDateTime } from "../lib/datetime";

const STATUS_COLORS: Record<string, string> = {
  success: "#2d7a33",
  partial: "#8a6d3b",
  failed: "#c0392b",
  aborted_threshold: "#c0392b",
  aborted_empty: "#c0392b",
  aborted_stale: "#c0392b",
  running: "#3b3b98",
};

export function RunStatus({ run }: { run: SyncRun }) {
  return (
    <span
      className="status-badge"
      style={{ background: STATUS_COLORS[run.status] ?? "#666" }}
    >
      {run.status}
      {run.dryRun ? " · dry-run" : ""}
    </span>
  );
}

/** The audit email's fate, in a word. A run with none recorded never emailed. */
export function emailLabel(run: SyncRun): string {
  switch (run.emailStatus) {
    case "sent":
      return "sent";
    case "failed":
      return "FAILED";
    case "skipped":
      return "email off";
    case "unrecorded":
      return "—";
    default:
      return run.status === "running" ? "…" : "not sent";
  }
}

export function RunsTable({ runs }: { runs: SyncRun[] }) {
  if (runs.length === 0) return <p className="muted">No runs yet.</p>;
  return (
    <table>
      <thead>
        <tr>
          <th>Started</th>
          <th>Trigger</th>
          <th>Status</th>
          <th>Locked / would</th>
          <th>Email</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {runs.map((r) => (
          <tr key={r.id}>
            <td>{fmtSgtDateTime(r.startedAt)}</td>
            <td>{r.trigger}</td>
            <td>
              <RunStatus run={r} />
            </td>
            <td>{r.dryRun ? (r.summary?.wouldLock ?? "—") : (r.summary?.locked ?? "—")}</td>
            <td className={r.emailStatus === "failed" ? "error" : undefined}>
              {emailLabel(r)}
            </td>
            <td>
              <Link to={`/runs/${r.id}`}>view</Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
